var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMessageWhite = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6875 0.25C0.755859 0.25 0 1.00586 0 1.9375C0 2.46836 0.249609 2.96758 0.675 3.2875L8.325 9.025C8.72578 9.32383 9.27422 9.32383 9.675 9.025L17.325 3.2875C17.7504 2.96758 18 2.46836 18 1.9375C18 1.00586 17.2441 0.25 16.3125 0.25H1.6875V0.25ZM0 4.1875V11.5C0 12.741 1.00898 13.75 2.25 13.75H15.75C16.991 13.75 18 12.741 18 11.5V4.1875L10.35 9.925C9.96076 10.2176 9.48697 10.3759 9 10.3759C8.51303 10.3759 8.03924 10.2176 7.65 9.925L0 4.1875Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMessageWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/message-white.35ad0f8c873fbc1435318ccd81d32e4c.svg";